export interface CrudFormItemMenuItem {
  label: string;
  name?: string;
  data?: any;
}
